import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  CHANGE_PARTNER_ACCOUNT_OWNER,
  CHANGE_PARTNER_ACCOUNT_OWNER_SUCCESS,
  CHANGE_PARTNER_ACCOUNT_OWNER_FAILED,
} from '../../constants';

import { fetchAccountOverview } from '../../actions/account-actions';

import store from '../../store';

const changePartnerAccountOwner = (action$, state$) =>
  action$.pipe(
    ofType(CHANGE_PARTNER_ACCOUNT_OWNER),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/partners/${action.clientId}/owner?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {

          store.dispatch(fetchAccountOverview());
          return {
            type: CHANGE_PARTNER_ACCOUNT_OWNER_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: CHANGE_PARTNER_ACCOUNT_OWNER_FAILED,
            error,
          })
        )
      )
    )
  );

export default changePartnerAccountOwner;
